import { render, staticRenderFns } from "./QuizTreeNode.vue?vue&type=template&id=045778b0&scoped=true&"
import script from "./QuizTreeNode.vue?vue&type=script&lang=js&"
export * from "./QuizTreeNode.vue?vue&type=script&lang=js&"
import style0 from "./QuizTreeNode.vue?vue&type=style&index=0&id=045778b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045778b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
